import React from "react";
import Navigation from "../../Templates/Navigation/Navigation";
import Footer from "../../Templates/Footer/Footer";
import LoginTab from "../../Templates/LoginPage/LoginTab";

const LoginScreen = () => {
  return (
    <>
      <Navigation />
      <LoginTab />
      <Footer />
    </>
  );
};

export default LoginScreen;
